import { render, staticRenderFns } from "./ElementoForm.vue?vue&type=template&id=18e44b08&scoped=true"
import script from "./ElementoForm.vue?vue&type=script&lang=js"
export * from "./ElementoForm.vue?vue&type=script&lang=js"
import style0 from "./ElementoForm.vue?vue&type=style&index=0&id=18e44b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e44b08",
  null
  
)

export default component.exports